import React from 'react';
import VisaIcon from '@images/payment-icons/icon_visa.svg';
import MasterCardIcon from '@images/payment-icons/icon_mastercard.svg';
import PaypalIcon from '@images/payment-icons/icon_paypal.svg';
import PaySafecard from '@images/payment-icons/icon_paysafecard.svg';
import KlarnaIcon from '@images/payment-icons/icon_klarna.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';

/**
 * Payment Icons
 * @returns {JSX.Element}
 * @constructor
 */
const PaymentIcons = () => {
  return (
    <div className="payment-icons mt-8 sm:pt-2 sm:pb-2 block md:flex flex-wrap sm:flex-row md:space-x-6 justify-center content-center items-center">
      <div className="flex flex-wrap sm:flex-row md:space-x-6 justify-center content-center items-center">
        <div className="p-2">
          <LazyLoadImage src={VisaIcon} alt="payment icons" className="w-16 md:w-20" />
          {/*<img loading="lazy" src={VisaIcon} alt="payment icons" className="w-16 md:w-20" />*/}
        </div>
        <div className="p-2">
          <LazyLoadImage src={MasterCardIcon} alt="payment icons" className="w-16 md:w-20" />
          {/*<img loading="lazy" src={MasterCardIcon} alt="payment icons" className="w-16 md:w-20" />*/}
        </div>
        <div className="p-2">
          <LazyLoadImage src={PaypalIcon} alt="payment icons" className="w-16 md:w-20" />
          {/*<img loading="lazy" src={PaypalIcon} alt="payment icons" className="w-16 md:w-20" />*/}
        </div>
      </div>
      <div className="flex flex-wrap sm:flex-row md:space-x-6 justify-center content-center items-center">
        <div className="p-2">
          <LazyLoadImage src={PaySafecard} alt="payment icons" className="w-16 md:w-20" />
          {/*<img loading="lazy" src={PaySafecard} alt="payment icons" className="w-16 md:w-20" />*/}
        </div>
        <div className="p-2">
          <LazyLoadImage src={KlarnaIcon} alt="payment icons" className="w-16 md:w-20" />
          {/*<img loading="lazy" src={KlarnaIcon} alt="payment icons" className="w-16 md:w-20" />*/}
        </div>
      </div>
    </div>
  );
};

export default PaymentIcons;
